import styled from "styled-components";

export const FooterTop_Stripe = styled.div`
padding-top: 22px;
padding-bottom: 22px;
border-top: 1px solid #cdcdcd;
border-bottom: 1px solid #cdcdcd;
`
export const FooterTop_Link = styled.a`
font-size: 13px;
font-family: 'NotoSansKR-Medium';
font-stretch: normal;
font-style: normal;
line-height: 1.92;
letter-spacing: -0.65px;
text-align: left;
color: #666;
text-decoration: none;
cursor: pointer;
`

export const FooterBottom_Span = styled.span`
font-size: 14px;
font-family: 'NotoSansKR-Medium';
font-stretch: normal;
font-style: normal;
line-height: 1.69;
letter-spacing: -0.98px;
text-align: left;
color: #666;
`
export const FooterBottom_SpanTel = styled(FooterBottom_Span)`
font-size: 16px;
color:#191919;
`
export const FooterBottom_SpanBorder = styled(FooterBottom_Span)`
border-left: 1px solid #cdcdcd;
`